import * as PIXI from 'pixi.js';
import { Container } from "pixi.js";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import Layers from "slotworks/graphics/layers/layers";
import ExtendedSpine from "slotworks/graphics/spine/spine";
import spineManager from "slotworks/graphics/spine/spine-manager";
import soundManager from "slotworks/sound/sound-manager";
import deviceInfo from "slotworks/utils/device-info";
import Point from "slotworks/utils/geom/point";
import * as TweenJS from "slotworks/utils/tween";

declare const __DEBUG__: boolean;

export default class HarleyComponent {

    private layer: Layers;
    private spine: ExtendedSpine;

    private innerContainer: Container;

    private portrait: boolean = false;

    private mask: PIXI.Graphics;

    constructor() {
        this.layer = Layers.Custom.get("Harley");

        this.innerContainer = new Container();
        this.layer.add(this.innerContainer);

        this.spine = spineManager.createSpine("harley_character");

        this.innerContainer.addChild(this.spine as any);

        if (!deviceInfo.isDesktop) {
            deviceInfo.onLayoutChange.add(this.onLayoutChange);
            this.onLayoutChange();
        }

        if (__DEBUG__) {
            (window as any).harley = this.spine;
        }

        // "Idle125"
        // Spin_01-125
        // Spin_02-125
        // wins_01_LegRise125
        // wins_02_Shrag125
        // wins_03_Clap125
        // wins_04_HandsUp125
    }

    public show(instant: boolean = false, time: number = 400, portrait: boolean = false) {
        TweenJS.removeAll(this.spine);
        this.portrait = portrait;
        this.innerContainer.visible = canvasManager.orientation === Orientation.LANDSCAPE || this.portrait;
        if (instant) {
            this.spine.visible = true;
            // @ts-ignore
            this.spine.alpha = 1;
        } else {
            this.spine.visible = true;
            // @ts-ignore
            this.spine.alpha = 0;
            new TweenJS.Tween(this.spine)
                .to({ alpha: 1 }, time)
                .start();
        }
    }

    public hide(instant: boolean = false, time: number = 400) {
        this.portrait = false;
        this.innerContainer.visible = canvasManager.orientation === Orientation.LANDSCAPE || this.portrait;
        TweenJS.removeAll(this.spine);
        if (instant) {
            this.spine.visible = false;
            this.spine.x = 0;
        } else {
            new TweenJS.Tween(this.spine)
                .to({ alpha: 0 }, time)
                .onComplete(() => {
                    this.spine.x = 0;
                    this.spine.visible = false;
                })
                .start();
        }
    }

    public showIdleIntro(freespins: boolean = false) {
        this.resetSpine();
        this.spine.visible = true;
        this.layer.show();
        const point = this.layer.globalToLocal(new Point(freespins ? 978 : 1100, 530));
        this.spine.x = point.x;
        this.spine.y = point.y;
        // this.spine.visible = true;
        this.spine.play(0, "Idle125", true);
    }

    public showIdleFreespins() {
        this.resetSpine();
        // this.layer.show();
        const point = deviceInfo.isDesktop ? this.layer.globalToLocal(new Point(980, 530)) : this.layer.globalToLocal(new Point(380, deviceInfo.widePortrait ? 600 : 780));
        this.spine.x = point.x;
        this.spine.y = point.y;
        // this.spine.visible = true;
        this.spine.play(0, "Idle125", true);
    }

    public spin1() {
        this.resetSpine();
        // this.spine.visible = true;
        this.spine.play(0, "Spin_01-125", false);
        this.spine.state.addAnimation(0, "Idle125", true, 0);
    }

    public spin2() {
        this.resetSpine();
        this.spine.visible = true;
        this.spine.play(0, "Spin_02-125", false);
        this.spine.state.addAnimation(0, "Idle125", true, 0);
    }

    public hands() {
        this.spine.play(0, "wins_04_HandsUp125", false);
    }

    public clap(freespins: boolean = false) {
        if(freespins) {
            const point = this.layer.globalToLocal(new Point(978, 530));
            this.spine.x = point.x;
            this.spine.y = point.y;
        }

        this.spine.play(0, "wins_03_Clap125", false);
        this.spine.state.addAnimation(0, "Idle125", true, 0);
        if(this.innerContainer.visible) {
            soundManager.customEvent("harley_character_win");
        }
    }

    public hideSpine() {
        this.resetSpine();
        this.spine.visible = false;
    }

    private resetSpine() {
        this.spine.skeleton.setToSetupPose();
        // this.spine.state.tracks = [];
        this.spine.state.clearTracks();
    }

    private createMask() {
        if (!deviceInfo.isDesktop && canvasManager.orientation === Orientation.PORTRAIT && !deviceInfo.widePortrait) {
            const maskPosition = this.layer.getPosition("mask");
            if(!this.mask) {
                const graphic = new PIXI.Graphics();                
                this.layer.add(graphic);
                this.mask = graphic;
            }
            this.mask.clear();
            this.mask.beginFill(0xff0000);
            this.mask.drawRect(maskPosition.x, maskPosition.y, maskPosition.width, maskPosition.height);
            this.layer.container.mask = this.mask;
        }
    }

    private onLayoutChange = () => {
        setTimeout(() => {
            if(canvasManager.orientation === Orientation.PORTRAIT) {
                this.innerContainer.visible = this.portrait;
                const scale = deviceInfo.widePortrait ? 0.96 : 0.93;
                // @ts-ignore
                this.spine.scale.set(scale, scale);

                this.createMask();
            } else {
                this.innerContainer.visible = true;
                // @ts-ignore
                this.spine.scale.set(1, 1);
            }
        }, 1)
    }
}